var exports = {
  "n": "xaee3c4fa--daaeda--link",
};

module.exports = exports;
